import { Component, Inject, OnInit } from '@angular/core';
import { InputComponent } from '../../../../../shared/components/input/input.component';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { TegelModule } from '@scania/tegel-angular-17';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecebimentoService } from '../../../../../shared/services/recebimento.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { ToastState as ts } from '../../../../../shared/enums/toast-state.enum';
import { FilaSeguranca } from '../../../models/fila-seguranca';

import { DateHelper } from '../../../../../shared/helpers/date.helper';
import { FaseId } from '../../../../../shared/enums/fase.enum';
import { PhoneHelper } from '../../../../../shared/helpers/phone.helper';
import { CustomButtonComponent } from '../../../../../shared/components/custom-button/custom-button.component';
import { SmsTemplateType } from '../../../../../shared/enums/sms.enum';
import { NotificacaoService } from '../../../../../shared/services/notificacao.service';
import { SendSmsNotificationDTO } from '../../../models/sms-notification';

@Component({
  selector: 'app-sla-dialog-seguranca',
  imports: [
    ButtonComponent,
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
    CustomButtonComponent,
  ],
  templateUrl: './sla-dialog-seguranca.component.html',
  styleUrl: './sla-dialog-seguranca.component.scss',
})
export class SlaDialogSegurancaComponent implements OnInit {
  public fase = FaseId;
  public SmsTemplateType = SmsTemplateType;

  form: FormGroup;
  filaId: number;
  recebimentoId: number;

  constructor(
    private dialogRef: MatDialogRef<SlaDialogSegurancaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private fb: FormBuilder,
    private workflowService: RecebimentoService,
    private toast: ToastService,
    private notificacaoService: NotificacaoService,
  ) {
    this.filaId = data.id;
    this.recebimentoId = data.recebimentoId;

    const formattedDataEntrada = DateHelper.utcToLocalString(
      data.dataEntrada,
      'dd/MM/yyyy HH:mm:ss',
    );

    const driverInfo = data.driverInfo || {};

    const phone = data?.recebimento?.celular || driverInfo.phone || null;
    const fornecedorPreenchido =
      data?.recebimento?.fornecedor || driverInfo.fornMot || '';

    this.form = this.fb.group({
      senha: [data?.recebimento?.senha ?? ''],
      celular: [phone, [Validators.maxLength(19)]],
      dataEntrada: formattedDataEntrada,
      fornecedor: [fornecedorPreenchido, [Validators.maxLength(100)]],
      registro: [data?.recebimento?.registro ?? ''],
      notaFiscal: [data?.recebimento?.notaFiscal ?? ''],
      volume: [data?.recebimento?.volume ?? 0],
      critico: [data?.recebimento.critico ?? false],
      milkrun: [data?.recebimento.milkrun ?? false],
      controlCenter: [data?.recebimento?.controlCenter ?? false],
    });
  }

  ngOnInit(): void {
    const celularControl = this.form.get('celular');

    if (celularControl) {
      PhoneHelper.applyPhoneMaskOnInit(celularControl);
    }
  }

  processar(proximaFaseId: number) {
    if (this.form.invalid) {
      this.toast.showToast(
        ts.error,
        'Revise os campos destacados antes de continuar.',
      );
      return;
    }

    const formValues = this.form.value;

    const dto: FilaSeguranca = {
      filaId: this.filaId,
      recebimentoId: this.recebimentoId,
      proximaFaseId: proximaFaseId,
      celular: formValues.celular
        ? PhoneHelper.cleanForApi(formValues.celular)
        : null,
      fornecedor: formValues.fornecedor,
      registro: formValues.registro,
      notaFiscal: formValues.notaFiscal,
      volume: formValues.volume,
      critico: formValues.critico,
      milkrun: formValues.milkrun,
      controlCenter: formValues.controlCenter,
    };

    this.workflowService.processamentoSeguranca(dto).subscribe({
      next: (result) => {
        this.toast.showToast(ts.success, 'Processado com sucesso!');
        this.dialogRef.close(result.content);
      },
      error: (e) => this.toast.showToast(ts.error, e.error[0]),
    });
  }

  enviarSms(templateType: SmsTemplateType) {
    const celularForm = this.form.get('celular')?.value;
    const celular = celularForm
      ? PhoneHelper.cleanForApi(celularForm)
      : this.data?.recebimento?.celular;

    if (!celular) {
      this.toast.showToast(
        ts.warning,
        'Nenhum número de celular vinculado a este registro.',
      );
      return;
    }

    const dto: SendSmsNotificationDTO = {
      phoneNumber: celular,
      driverName:
        this.data?.driverInfo?.nomeMot || this.data?.motorista || 'Motorista',
      templateType,
      tipoLiberacao: null,
    };

    this.notificacaoService.sendSms(dto).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'SMS encaminhado para envio.');
        }
      },
      error: (e) => {
        const msg = e.error?.messages?.[0] || 'Falha ao enviar SMS.';
        this.toast.showToast(ts.error, msg);
      },
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
